import { v4 as uuidv4 } from 'uuid';

import { ActRejectionGridPluginSettings, ActRejectionPluginView } from '.';
import { CreateVariant } from '../../MasterTabsProvider';
import i18n from '../../../i18n';

export const ActRejectionTab = (variant?: CreateVariant): ITab => {
    return {
        id: uuidv4(),
        title: i18n.t("documents.actRejection.tabName"),
        view: {
            content: ActRejectionGridPluginSettings
                ? <ActRejectionPluginView gridId={uuidv4()} plugin={ActRejectionGridPluginSettings()} />
                : <p> {i18n.t("general.directoryNotConfigured")} </p>
        }
    }
}

export default ActRejectionTab